module.exports = __webpack_public_path__ + "static/img/images_ID001.83d76d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/images_ID001.png
// module id = v83h
// module chunks = 0